import React from 'react';
import { Link } from 'react-router-dom';

import AdvertList from '@Components/Advert/AdvertList';
import Col from '@Components/layout/Col';
import Row from '@Components/layout/Row';
import SearchItemsContentLoader from '@Components/Loaders/SearchItemsContentLoader';
import Typography from '@Components/Typography';
import { Messages } from '@Config/messages';
import { RouteConfig } from '@Config/routes';
import { ParentCategoryFragment, useGetMarketplaceAdsQuery } from '@Graphql/graphqlTypes.generated';
import { useTranslations } from '@Hooks/useTranslations';

import styles from './FeaturedAdverts.module.scss';

interface FeaturedAdvertsProps {
  itemsCount: number;
  hideShowMore?: boolean;
  featuredCategory: ParentCategoryFragment | undefined;
  onCompleted?: () => void;
}

const FeaturedAdverts: React.FunctionComponent<FeaturedAdvertsProps> = ({
  itemsCount,
  hideShowMore,
  featuredCategory,
  onCompleted,
}) => {
  const t = useTranslations();

  const { data, loading } = useGetMarketplaceAdsQuery({
    variables: { limit: itemsCount, categories: [featuredCategory?.id || ''] },
    fetchPolicy: 'network-only',
    onCompleted,
  });

  const adverts = data?.allAdverts?.edges.map(item => item.node);

  return (
    <div className={styles.featuredItemContainer}>
      {loading ? (
        <SearchItemsContentLoader count={itemsCount} gridSize={itemsCount} />
      ) : (
        <AdvertList adverts={adverts || []} />
      )}
      {!hideShowMore && (
        <Row size="size3">
          <Col size={3}>
            <Link to={RouteConfig.Marketplace.buildLink()}>
              <Typography className={styles.moreLink} bold msg={t(Messages.labelSeeMoreAdverts)} tag="span" />
            </Link>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default FeaturedAdverts;
